<template lang="pug">
  .cursor-pointer(:class="customClasses" @click="handleClick")
    div(:class="checkboxClasses")
      input.appearance-none.outline-none(:checked="checked" :value="checkboxValue" type="checkbox")
      div(v-if="checked" :class="checkedCheckboxClasses")
        span
          slot(name='checkedIcon')
    slot
</template>

<script>
export default {
  name: 'SwCheckbox',
  inject: {
    checkboxGroupValueArray: { default: null },
    updateCheckboxGroupValueArray: { default: null },
  },
  props: {
    value: {
      type: Boolean,
      default: false,
    },
    checkboxValue: {
      type: String,
      default: null,
    },
    customClasses: {
      type: String,
      default: '',
    },
    checkboxClasses: {
      type: String,
      default: '',
    },
    checkedCheckboxClasses: {
      type: String,
      default: '',
    },
  },
  computed: {
    checked () {
      return this.checkboxGroupValueArray ? this.checkboxGroupValueArray.indexOf(this.checkboxValue) !== -1 : this.value;
    },
  },
  methods: {
    handleClick () {
      this.checkboxGroupValueArray ? this.updateCheckboxGroupValueArray(this.checkboxValue) : this.$emit('input', !this.value);
    },
  },
};
</script>
